module.exports = __webpack_public_path__ + "img/10-5.b0c318d6.png";